import { UploadProgress } from 'src/components/upload-progress';

export default UploadProgress;
